// 한 직원의 주간 근무시간 보기 — 관리자 팝업과 개인 QR 페이지가 함께 쓴다.
// 야근+조근(12시간 기준선 막대) · 내역 칩 · 요일별 기록 · 최근 주별 야근+조근 추세(막대 탭 → 그 주로 이동)
import React from 'react';
import dayjs from 'dayjs';
import '../styles/Common.css';

const fmtH = (v) => (Number.isInteger(v) ? String(v) : Number(v).toFixed(1));

const WorkHoursWeekView = ({ week, trend = [], limit = 12, t, onSelectWeek }) => {
  if (!week) return null;
  const scale = Math.max(16, week.checked_hours + 2);
  const pct = (v) => `${Math.min(100, (v / scale) * 100)}%`;
  const trendMax = Math.max(16, ...trend.map((w) => w.checked_hours));
  const status = week.status.toLowerCase();

  return (
    <div className="whv">
      <div className={`whv-total is-${status}`}>
        <div className="whv-total-num">
          <small className="whv-total-label">{t.checked}</small>
          <b>{fmtH(week.checked_hours)}</b>
          <span>{t.hours}</span>
          <em className={`whv-status is-${status}`}>{t[week.status]}</em>
        </div>
        <div className="whv-bar" aria-hidden="true">
          <div className={`whv-bar-ot is-${status}`} style={{ left: 0, width: pct(week.checked_hours) }} />
          <i className="whv-bar-limit" style={{ left: pct(limit) }}><span>{limit}</span></i>
        </div>
        <div className="whv-chips">
          <span>{t.EVENING} <b>{fmtH(week.weekday_overtime_hours)}</b></span>
          <span>{t.EARLY} <b>{fmtH(week.early_overtime_hours)}</b></span>
          <span>{t.WEEKEND} <b>{fmtH(week.weekend_overtime_hours)}</b></span>
        </div>
      </div>

      <ul className="whv-days">
        {week.days.map((d) => {
          const dayTotal = d.overtime_hours;
          return (
            <li key={d.date} className={`whv-day${d.is_off ? ' is-off' : ''}${dayTotal === 0 ? ' is-empty' : ''}`}>
              <div className="whv-day-label">
                <b>{t.weekdays[d.weekday]}</b>
                <span>{dayjs(d.date).format('M/D')}</span>
              </div>
              <div className="whv-day-body">
                {d.holiday && <span className="whv-holiday">{t.holiday} · {d.holiday}</span>}
                {d.records.map((r, i) => (
                  <span key={i} className={`whv-rec ${r.type.toLowerCase()}`} title={r.note || undefined}>
                    {t[r.type]} {r.start}–{r.end} <b>{fmtH(r.hours)}</b>
                    {r.note ? <small>{r.note}</small> : null}
                  </span>
                ))}
                {dayTotal === 0 && !d.holiday && <span className="whv-none">{t.noRecord}</span>}
              </div>
              <div className="whv-day-total">{dayTotal ? fmtH(dayTotal) : ''}</div>
            </li>
          );
        })}
      </ul>

      {trend.length > 0 && (
        <div className="whv-trend">
          <div className="whv-trend-title">{t.recent}</div>
          <div className="whv-trend-bars">
            <i className="whv-trend-limit" style={{ bottom: `${(limit / trendMax) * 100}%` }} />
            {trend.map((w) => (
              <button
                type="button"
                key={w.week_start}
                className={`whv-trend-col${w.week_start === week.week_start ? ' is-current' : ''}`}
                onClick={onSelectWeek ? () => onSelectWeek(w.week_start) : undefined}
                aria-label={`${w.week_start} ${fmtH(w.checked_hours)}`}
              >
                <span className={`whv-trend-bar is-${w.status.toLowerCase()}`} style={{ height: `${(w.checked_hours / trendMax) * 100}%` }} />
              </button>
            ))}
          </div>
          <div className="whv-trend-axis">
            <span>{dayjs(trend[0].week_start).format('M/D')}</span>
            <span>{dayjs(trend[trend.length - 1].week_start).format('M/D')}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkHoursWeekView;
